import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getCouponData } from './couponServices';
import { getShouldExcludeBraze } from './getShouldExcludeBraze';
var CS_ITEM_ID = '5388';

/**
 * Determines if a user should see Coupon Applied Banner, based on if they
 * have an auto-applied coupon or if they are included in a conflicting experiment.
 */

var getShouldRenderCAB = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(baseUrl, sdkKey) {
    var _fetchedCoupon$autoAp;
    var conditionParams,
      fetchedCoupon,
      hasAutoAppliedCoupon,
      excludedFromBraze,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          conditionParams = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          _context.next = 3;
          return getCouponData(CS_ITEM_ID, baseUrl, sdkKey);
        case 3:
          fetchedCoupon = _context.sent;
          hasAutoAppliedCoupon = fetchedCoupon === null || fetchedCoupon === void 0 || (_fetchedCoupon$autoAp = fetchedCoupon.autoApplyCoupon) === null || _fetchedCoupon$autoAp === void 0 || (_fetchedCoupon$autoAp = _fetchedCoupon$autoAp.data) === null || _fetchedCoupon$autoAp === void 0 ? void 0 : _fetchedCoupon$autoAp.couponCode;
          excludedFromBraze = getShouldExcludeBraze({
            conditionParams: conditionParams
          });
          return _context.abrupt("return", !(hasAutoAppliedCoupon || excludedFromBraze));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getShouldRenderCAB(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default getShouldRenderCAB;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getShouldRenderCAB.js
// module id = 4122
// module chunks = 11